import { FormConfig } from 'src/shared/form-models/form-cva.component';
import {
	Component,
	OnInit,
	OnDestroy,
	ViewChildren,
	QueryList,
} from '@angular/core';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { select, Store } from '@ngrx/store';
import { RailroadDetailPartialState } from './+state/railroad-detail.reducer';
import { FormBuilder, FormControlName, FormGroup } from '@angular/forms';
import { takeUntil, shareReplay, map, debounceTime } from 'rxjs/operators';
import { RailroadDetails } from './railroad-detail.models';
import { touchAllControls } from 'src/shared/utilities/utility-functions';
import * as RailroadDetailSelectors from './+state/railroad-detail.selectors';
import * as RailroadDetailActions from './+state/railroad-detail.actions';
import { preventFlicker } from 'src/shared/utilities/custom-rxjs-operators';
import { Subject } from 'rxjs';

const railroadDetailsFormConfig: FormConfig<RailroadDetails> = {
	generalInfo: [''],
	address: [''],
	documents: [[]],
	contacts: [[]],
	divisions: [[]],
	offeredServices: [[]],
	subCodes: [[]],
	contractedRates: [''],
	payrollOptions: [''],
	optionalJobFieldsToShow: [''],
};

@Component({
	templateUrl: './railroad-detail.component.html',
})
export class RailroadDetailComponent extends SelfDestruct
	implements OnInit, OnDestroy {
	@ViewChildren(FormControlName) childControls: QueryList<FormControlName>;
	private _invalidSubmission = new Subject<number>();

	form = this.fb.group(railroadDetailsFormConfig) as FormGroup;

	readonly id$ = this.store.pipe(
		select(RailroadDetailSelectors.getSelectedRailroadId)
	);

	readonly isExistingRailroad$ = this.store.pipe(
		select(RailroadDetailSelectors.getSelectedRailroadId),
		map((id) => id !== 0),
		debounceTime(200),
		shareReplay(1)
	);

	readonly isLoadingRailroad$ = this.store.pipe(
		select(RailroadDetailSelectors.getLoadingStatus),
		shareReplay(1)
	);

	readonly isSaving$ = this.store.pipe(
		select(RailroadDetailSelectors.getIsSaving),
		preventFlicker(1000)
	);

	readonly isFormInvalid$ = this.store.pipe(
		select(RailroadDetailSelectors.getError)
	);

	readonly customers$ = this.store.pipe(
		select(RailroadDetailSelectors.getCustomers)
	);

	readonly rwics$ = this.store.pipe(select(RailroadDetailSelectors.getRwics));

	readonly jobs$ = this.store.pipe(select(RailroadDetailSelectors.getJobs));

	readonly title$ = this.store.pipe(select(RailroadDetailSelectors.getTitle));

	readonly invalidSubmission$ = this._invalidSubmission.asObservable();

	constructor(
		private readonly store: Store<RailroadDetailPartialState>,
		private readonly fb: FormBuilder
	) {
		super();
	}

	ngOnInit() {
		this.store
			.pipe(
				select(RailroadDetailSelectors.getSelectedRailroadForm),
				takeUntil(this.destroyed)
			)
			.subscribe((formValue) => this.form.patchValue(formValue));
	}

	save(stay = false) {
		if (this.form.valid) {
			const formValue = this.form.value;
			this.store.dispatch(
				RailroadDetailActions.saveRequested({
					shouldStayOnPage: stay,
					formValue,
				})
			);
		} else {
			touchAllControls(this.childControls);
			this._invalidSubmission.next(new Date().getTime());
		}
	}

	ngOnDestroy() {
		this.store.dispatch(RailroadDetailActions.railroadDetailDestroyed());
		super.ngOnDestroy();
	}
}
